import { Box, styled, Typography } from '@mui/material';

export const SelectionSummaryStyled = styled(Box)`
    float:right;
    margin-right: 60px;
    margin-top: -35px;
`;